import { TankersEvent } from '../types/ViewModel/TankersEvent';
import { isDateSame } from 'odfjell-date-time-utils/dateTimeUtils';

export const transform = (array: TankersEvent[], isDescendingSort: boolean): TankersEvent[] => {
    array.sort((a: TankersEvent, b: TankersEvent) => {
        const aDate: Date | null = getPlannedOrActualDateFromEvent(a);
        const bDate: Date | null = getPlannedOrActualDateFromEvent(b);

        if (aDate && bDate && a.created && b.created) {
            if (aDate < bDate || (isSameDateAndTime(aDate, bDate) && a.created < b.created)) {
                return isDescendingSort ? 1 : -1;
            } else if (aDate > bDate || (isSameDateAndTime(aDate, bDate) && a.created > b.created)) {
                return isDescendingSort ? -1 : 1;
            }
        }
        return 0;
    });
    return array;
};

const getPlannedOrActualDateFromEvent = (event: TankersEvent): Date | null => {
    if (event.eventDate.actualDateTimeUtc) {
        return getDateWithoutSecMs(event.eventDate.actualDateTimeUtc);
    }
    return getDateWithoutSecMs(event.eventDate.plannedDateTimeUtc);
};

const getDateWithoutSecMs = (evDate: Date | null): Date | null => {
    if (evDate) {
        evDate.setSeconds(0, 0);
        return evDate;
    }
    return null;
};

const isSameDateAndTime = (aDate: Date, bDate: Date): boolean => {
    return (
        isDateSame(aDate, bDate, 'year') &&
        isDateSame(aDate, bDate, 'month') &&
        isDateSame(aDate, bDate, 'day') &&
        isDateSame(aDate, bDate, 'hour') &&
        isDateSame(aDate, bDate, 'minute') &&
        isDateSame(aDate, bDate, 'second')
    );
};
